import { Component, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core';
import { Router } from '@angular/router';

import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as StrategyActions from '../../strategy.actions';
import * as fromStrategy from '../../reducers';

@Component({
  selector: 'app-strategy-was-changed-modal',
  templateUrl: './strategy-was-changed-modal.component.html',
  standalone: false
})
export class StrategyWasChangedModalComponent implements OnDestroy {
  @Input() enableSaveButton = true;
  @Input() stepStatus: number;
  @Input() qlOnboardingStep: number;
  @Output() discardChangesEmitter = new EventEmitter<boolean>();
  @Output() saveChangesEmitter = new EventEmitter<boolean>();
  strategyWasChanged: { modalOpened: boolean; redirectUrl: string; strategyWasChanged: boolean };
  protected readonly onDestroy$ = new Subject<void>();

  @HostListener('window:beforeunload', ['$event'])
  confirmLeave($event: { returnValue: string; preventDefault: () => void }) {
    if (!this.strategyWasChanged.strategyWasChanged) {
      return undefined;
    }
    return ($event.returnValue = 'Do you want to leave this site? Changes you made may not be saved.');
  }

  constructor(
    private store: Store,
    private router: Router
  ) {
    this.store.pipe(select(fromStrategy.selectStrategyWasChanged), takeUntil(this.onDestroy$)).subscribe((value) => {
      this.strategyWasChanged = value;
    });
  }

  closeModal(): void {
    this.store.dispatch(StrategyActions.setStrategyWasChanged({ strategyWasChanged: true, modalOpened: false, redirectUrl: '' }));
  }

  discardChanges(): void {
    this.discardChangesEmitter.emit(true);
    this.redirect();
  }

  saveChanges(): void {
    this.saveChangesEmitter.emit(this.stepStatus > 1);
  }

  ngOnDestroy(): void {
    this.store.dispatch(StrategyActions.setStrategyWasChanged({ modalOpened: false, redirectUrl: '', strategyWasChanged: false }));
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  private redirect() {
    const tabIndex = this.stepStatus > 1 ? 5 : this.qlOnboardingStep;
    if (this.strategyWasChanged.redirectUrl && this.strategyWasChanged.redirectUrl.includes('strategy/')) {
      this.store.dispatch(
        StrategyActions.setTabIndex({
          tabIndex: Number(this.strategyWasChanged.redirectUrl[this.strategyWasChanged.redirectUrl.length - 1])
        })
      );
    } else if (this.strategyWasChanged.redirectUrl && this.strategyWasChanged.redirectUrl.includes('strategy')) {
      this.store.dispatch(StrategyActions.setTabIndex({ tabIndex }));
    } else {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.router.navigateByUrl(this.strategyWasChanged.redirectUrl);
    }
  }
}
